import * as RouterStoreSelectors from './router.selector';
import { MemoizedSelector } from '@ngrx/store';

export const selectRolloutsId: MemoizedSelector<object, string> = RouterStoreSelectors.selectRouterParam('rollouts-id');
